<template>
  <div id="plugins">

    <v-toolbar class="blue-grey lighten-5" dark tabs extended  flat height="70px">

      <v-toolbar-title class="grey--text text--darken-4 mt-4">
        <h2>
          <v-icon  class="grey--text text--darken-4">
            track_changes
          </v-icon>
          {{$t("settings.available-sensor")}}
        </h2>
      </v-toolbar-title>

      <v-tabs
        slot="extension"
        slider-color="grey"
        color="blue-grey lighten-5"
        v-model="currentTab"
      >
        <v-tab
          key="flowsensor"
          href="#flowsensor"
          class="grey--text text--darken-4"
        >
        {{$t("sensor.flow")}}
        </v-tab>
        <v-tab
          key="tdssensor"
          href="#tdssensor"
          class="grey--text text--darken-4"
        >
        {{$t("sensor.tds")}}
        </v-tab>
        <v-tab
          key="pressuresensor"
          href="#pressuresensor"
          class="grey--text text--darken-4"
        >
        {{$t("sensor.pressure")}}
        </v-tab>
        <v-tab
          key="leakagesensor"
          href="#leakagesensor"
          class="grey--text text--darken-4"
        >
        {{$t("sensor.leakage")}}
        </v-tab>
        <v-tab
          key="temperaturesensor"
          href="#temperaturesensor"
          class="grey--text text--darken-4"
        >
        {{$t("sensor.temperature")}}
        </v-tab>

      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="currentTab">

      <!-- 流量センサー -->
      <v-tab-item key="flowsensor" id="flowsensor">

        <v-layout>
          <v-spacer></v-spacer>
          <v-flex xs4 class="pr-2">
            <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="searchFlowsensor"
            class="search"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-data-table
          :headers="headersFlowsensor"
          hide-actions
          :items="flowsensors"
          disabled-initial-sort
          item-key="id"
          :search="searchFlowsensor"
        >

          <template slot="items" slot-scope="props">
            <tr>
              <td>{{props.item.id}}</td>
              <td>{{props.item.name}}</td>
              <td>{{props.item.description}}</td>
            </tr>
          </template>

        </v-data-table>

      </v-tab-item>

      <!-- TDSセンサー -->
      <v-tab-item key="tdssensor" id="tdssensor">

        <v-layout>
          <v-spacer></v-spacer>
          <v-flex xs4 class="pr-2">
            <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="searchTdssensor"
            class="search"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-data-table
          :headers="headersTdssensor"
          hide-actions
          :items="tdssensors"
          disabled-initial-sort
          item-key="id"
          :search="searchTdssensor"
        >

          <template slot="items" slot-scope="props">
            <tr>
              <td>{{props.item.id}}</td>
              <td>{{props.item.name}}</td>
              <td>{{props.item.description}}</td>
            </tr>
          </template>

        </v-data-table>

      </v-tab-item>

      <!-- 圧力センサー -->
      <v-tab-item key="pressuresensor" id="pressuresensor">

        <v-layout>
          <v-spacer></v-spacer>
          <v-flex xs4 class="pr-2">
            <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="searchPressuresensor"
            class="search"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-data-table
          :headers="headersPressuresensor"
          hide-actions
          :items="pressuresensors"
          disabled-initial-sort
          item-key="id"
          :search="searchPressuresensor"
        >

          <template slot="items" slot-scope="props">
            <tr>
              <td>{{props.item.id}}</td>
              <td>{{props.item.name}}</td>
              <td>{{props.item.description}}</td>
            </tr>
          </template>

        </v-data-table>

      </v-tab-item>

      <!-- 漏水センサー -->
      <v-tab-item key="leakagesensor" id="leakagesensor">

        <v-layout>
          <v-spacer></v-spacer>
          <v-flex xs4 class="pr-2">
            <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="searchLeakagesensor"
            class="search"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-data-table
          :headers="headersLeakagesensor"
          hide-actions
          :items="leakagesensors"
          disabled-initial-sort
          item-key="id"
          :search="searchLeakagesensor"
        >

          <template slot="items" slot-scope="props">
            <tr>
              <td>{{props.item.id}}</td>
              <td>{{props.item.name}}</td>
              <td>{{props.item.description}}</td>
            </tr>
          </template>

        </v-data-table>

      </v-tab-item>

      <!-- 温度センサー -->
      <v-tab-item key="temperaturesensor" id="temperaturesensor">

        <v-layout>
          <v-spacer></v-spacer>
          <v-flex xs4 class="pr-2">
            <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="searchTemperaturesensor"
            class="search"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-data-table
          :headers="headersTemperturesensor"
          hide-actions
          :items="temperaturesensors"
          disabled-initial-sort
          item-key="id"
          :search="searchTemperaturesensor"
        >

          <template slot="items" slot-scope="props">
            <tr>
              <td>{{props.item.id}}</td>
              <td>{{props.item.name}}</td>
              <td>{{props.item.description}}</td>
            </tr>
          </template>

        </v-data-table>

      </v-tab-item>

    </v-tabs-items>
  </div>
</template>

<script>
import http from '@/utils/http.js'

export default {
  name: 'plugins',
  data () {
    return {
      currentTab: '',
      // 多言語対応のためハードコーディング TODO:共通化
      pluginName: {
        1: '流量センサー',
        2: 'TDSセンサー',
        3: '温度センサー',
        4: '漏水センサー',
        5: '圧力センサー'
      },
      flowsensors: [],
      tdssensors: [],
      pressuresensors: [],
      leakagesensors: [],
      temperaturesensors: [],
      // テーブル用の変数
      searchFlowsensor: '',
      headersFlowsensor: [
        {text: 'ID', value: 'id'},
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'}
      ],
      // テーブル用の変数
      searchTdssensor: '',
      headersTdssensor: [
        {text: 'ID', value: 'id'},
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'}
      ],
      // テーブル用の変数
      searchTemperaturesensor: '',
      headersTemperturesensor: [
        {text: 'ID', value: 'id'},
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'}
      ],
      // テーブル用の変数
      searchLeakagesensor: '',
      headersLeakagesensor: [
        {text: 'ID', value: 'id'},
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'}
      ],
      // テーブル用の変数
      searchPressuresensor: '',
      headersPressuresensor: [
        {text: 'ID', value: 'id'},
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'}
      ]
    }
  },
  methods: {
    init () {
      this.getFlowsensors()
      this.getTdssensors()
      this.getPressuresensors()
      this.getLeakagesensors()
      this.getTemperaturesensors()
    },
    getFlowsensors () {
      this.getPlugins(1).then((value) => {
        this.flowsensors = value
      })
    },
    getTdssensors () {
      this.getPlugins(2).then((value) => {
        this.tdssensors = value
      })
    },
    getTemperaturesensors () {
      this.getPlugins(3).then((value) => {
        this.temperaturesensors = value
      })
    },
    getLeakagesensors () {
      this.getPlugins(4).then((value) => {
        this.leakagesensors = value
      })
    },
    getPressuresensors () {
      this.getPlugins(5).then((value) => {
        this.pressuresensors = value
      })
    },
    getPlugins (pluginId) {
      return new Promise((resolve, reject) => {
        let pluginName = this.pluginName[pluginId]
        http.request('get', '/service2/dashboard/api/Plugins/pluginList/' + pluginId)
        .then(response => {
          const data = response.data
          console.log(data)
          if (data.result !== 0) {
            console.log(pluginName + ' list get failed. (' + data.result + ')')
            resolve([])
          }
          resolve(data.plugins)
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
          resolve([])
        })
      })
    },
    currentTabSet () {
      this.currentTab = location.hash.replace('#', '')
    }
  },
  mounted () {
    this.init()
    this.currentTabSet()
  },
  watch: {
    '$route' () {
      this.currentTabSet()
    }
  }
}

</script>


<style>

/* 検索窓のカスタマイズ */
.search .input-group {
  padding:0px;
}
.search  .input-group__input{
  padding: 2px;
  background-color: #DDD;
  border-radius:5px;
}
.search .input-group__details:before {
  background-color: rgba(0,0,0,0)!important;
}

#plugins table.table thead tr {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// SettingsPlugins.vue?9df23cfa